import { render } from "./SelectUi.vue?vue&type=template&id=356e65a4&scoped=true&ts=true"
import script from "./SelectUi.vue?vue&type=script&lang=ts"
export * from "./SelectUi.vue?vue&type=script&lang=ts"

import "./SelectUi.vue?vue&type=style&index=0&id=356e65a4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-356e65a4"]])

export default __exports__